"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * This is exported as a separate function so that we can mock it.
 * @alias isInDev
 * @internal
 */
var _default = function _default() {
  return process.env.NODE_ENV === 'development';
};

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pc0luRGV2LnRzIl0sIm5hbWVzIjpbInByb2Nlc3MiLCJlbnYiLCJOT0RFX0VOViJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7ZUFDZTtBQUFBLFNBQWVBLE9BQU8sQ0FBQ0MsR0FBUixDQUFZQyxRQUFaLEtBQXlCLGFBQXhDO0FBQUEsQyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogVGhpcyBpcyBleHBvcnRlZCBhcyBhIHNlcGFyYXRlIGZ1bmN0aW9uIHNvIHRoYXQgd2UgY2FuIG1vY2sgaXQuXG4gKiBAYWxpYXMgaXNJbkRldlxuICogQGludGVybmFsXG4gKi9cbmV4cG9ydCBkZWZhdWx0ICgpOiBib29sZWFuID0+IHByb2Nlc3MuZW52Lk5PREVfRU5WID09PSAnZGV2ZWxvcG1lbnQnO1xuIl19